import { useMutation, useQueryClient } from '@tanstack/react-query'
import { analyzeImport, applyImportSuggestions } from '../services/negotiationsApi'
import type { ImportSelections } from '../services/negotiationsApi'

export function useAnalyzeImport(negotiationId: number) {
  return useMutation({
    mutationFn: () => analyzeImport(negotiationId),
  })
}

export function useApplyImportSuggestions(negotiationId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (selections: ImportSelections) =>
      applyImportSuggestions(negotiationId, selections),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['negotiations'] })
    },
  })
}
